"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationSearchResponse = void 0;
const common_1 = require("../../common");
const models_1 = require("../models");
class LocationSearchResponse extends common_1.PaginatedResponse {
}
exports.LocationSearchResponse = LocationSearchResponse;
//# sourceMappingURL=location-search.response.js.map